var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33325 12H22.3333M2.33325 12C2.33325 17.5228 6.8104 22 12.3333 22M2.33325 12C2.33325 6.47715 6.8104 2 12.3333 2M22.3333 12C22.3333 17.5228 17.8561 22 12.3333 22M22.3333 12C22.3333 6.47715 17.8561 2 12.3333 2M12.3333 2C14.8345 4.73835 16.256 8.29203 16.3333 12C16.256 15.708 14.8345 19.2616 12.3333 22M12.3333 2C9.83197 4.73835 8.4105 8.29203 8.33325 12C8.4105 15.708 9.83197 19.2616 12.3333 22",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.afa986442ece1e5789a816c58aa76501.svg";
export { ForwardRef as ReactComponent };